/**
 * Viewmodel for mail job status
 */
export class MailJobSummary {
    
    public pendingDocumentCount : number = 0;
    public pendingPageCount : number = 0;

    public openJobs : number = 0;
    public printedJobs : number = 0;

}
